import { render, staticRenderFns } from "./DeviceDetailsReviewSkeleton.vue?vue&type=template&id=f0c68ea4"
import script from "./DeviceDetailsReviewSkeleton.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsReviewSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports